import './index.css';
import { jsx } from 'react/jsx-runtime';
import React from 'react';

var styles = {"vertically-centered-icon":"magritte-vertically-centered-icon___Zstk8_5-0-9","verticallyCenteredIcon":"magritte-vertically-centered-icon___Zstk8_5-0-9"};

const VerticallyCenteredIcon = ({ icon, 'data-qa': dataQa }) => {
    return (jsx("span", { className: styles.verticallyCenteredIcon, children: React.cloneElement(icon, {
            'data-qa': dataQa,
        }) }));
};

export { VerticallyCenteredIcon as default };
//# sourceMappingURL=VerticallyCenteredIcon.js.map
